module.exports = __webpack_public_path__ + "NPM Import Template.xlsx";